(function(){
  'use strict';
  function findVariant(variants,id){return variants.find(function(variant){return String(variant.id)===String(id);});}
  function signaturePrice(count,settings){return Number(settings.baseAmount)+(Number(count)-Number(settings.min))*Number(settings.extraAmount);}
  function findRoseVariant(variants,count,amount){return variants.find(function(variant){var match=String(variant.title||'').match(/\d+/);return match&&Number(match[0])===Number(count)&&Number(variant.amount)===Number(amount);});}
  function purchaseTotal(amount,addons){return addons.reduce(function(total,addon){return total+Number(addon.price);},Number(amount));}
  function buildCartItems(entries,addons){
    var fields=Object.fromEntries(entries);
    var quantity=Math.max(1,parseInt(fields.quantity,10)||1);
    var main={id:String(fields.id),quantity:quantity};
    var properties={};
    Object.keys(fields).forEach(function(key){var match=/^properties\[(.+)\]$/.exec(key);if(match&&fields[key]!=='')properties[match[1]]=fields[key];});
    if(Object.keys(properties).length)main.properties=properties;
    if(fields.selling_plan)main.selling_plan=fields.selling_plan;
    return [main].concat(addons.map(function(addon){return {id:String(addon.id),quantity:quantity};}));
  }
  if(typeof module!=='undefined'&&module.exports)module.exports={findVariant:findVariant,purchaseTotal:purchaseTotal,buildCartItems:buildCartItems,signaturePrice:signaturePrice,findRoseVariant:findRoseVariant};
  if(typeof document==='undefined')return;
  function initialize(root){
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    var config=JSON.parse(root.querySelector('[data-product-config]').textContent);
    var select=root.querySelector('[data-variant-select]');
    var form=root.querySelector('.qr-product-form');
    var addonFieldset=root.querySelector('[data-product-addons]');
    var signature=config.signature||null;
    var roseCount=signature?Number(signature.min):null;
    var rosePicker=root.querySelector('[data-rose-picker]');
    var busy=false;
    var requiresCartReview=false;
    function currentVariant(){return signature?findRoseVariant(config.variants,roseCount,signaturePrice(roseCount,signature)):findVariant(config.variants,form.elements.id.value);}
    function formatAmount(amount){return new Intl.NumberFormat(config.locale,{style:'currency',currency:config.currency}).format(amount/100);}
    function selectedAddons(){return Array.from(root.querySelectorAll('[data-addon-variant]:checked')).map(function(input){return {id:input.dataset.addonVariant,price:Number(input.dataset.addonPrice)};});}
    function updateTotals(){
      var variant=currentVariant();
      if(!variant&&!signature)return;
      var addons=selectedAddons();
      var amount=signature?signaturePrice(roseCount,signature):variant.amount;
      var total=signature||addons.length?formatAmount(purchaseTotal(amount,addons)):variant.price;
      root.querySelectorAll('[data-purchase-total],[data-addon-total]').forEach(function(node){node.textContent=total;});
      var summary=root.querySelector('[data-addon-summary]');if(summary)summary.hidden=!addons.length;
    }
    function updateRosePicker(){
      var amount=signaturePrice(roseCount,signature),variant=currentVariant();
      form.elements.id.value=variant?String(variant.id):'';
      rosePicker.querySelector('[data-rose-count]').textContent=signature.countLabel.replace('__COUNT__',String(roseCount));
      rosePicker.querySelector('[data-rose-minus]').disabled=roseCount<=signature.min||busy||requiresCartReview;
      rosePicker.querySelector('[data-rose-plus]').disabled=roseCount>=signature.max||busy||requiresCartReview;
      var status=rosePicker.querySelector('[data-rose-status]');status.hidden=!!variant;
      root.querySelectorAll('[data-variant-price]').forEach(function(node){node.textContent=formatAmount(amount);});
      root.querySelectorAll('[data-product-add]').forEach(function(button){button.disabled=!variant||!variant.available||busy||requiresCartReview;});
      root.querySelectorAll('[data-add-label]').forEach(function(node){node.textContent=variant&&!variant.available?config.soldOutLabel:config.availableLabel;});
      updateTotals();
    }
    if(signature&&rosePicker){
      rosePicker.querySelector('[data-rose-minus]').addEventListener('click',function(){if(busy||requiresCartReview)return;roseCount=Math.max(Number(signature.min),roseCount-1);updateRosePicker();});
      rosePicker.querySelector('[data-rose-plus]').addEventListener('click',function(){if(busy||requiresCartReview)return;roseCount=Math.min(Number(signature.max),roseCount+1);updateRosePicker();});
      form.addEventListener('submit',function(event){var variant=currentVariant();if(!variant||!variant.available){event.preventDefault();if(!variant){var status=rosePicker.querySelector('[data-rose-status]');status.hidden=false;status.focus();}}});
      updateRosePicker();
    }
    if(addonFieldset&&window.fetch&&window.FormData){
      addonFieldset.hidden=false;addonFieldset.disabled=false;
      addonFieldset.addEventListener('change',updateTotals);
      form.addEventListener('submit',async function(event){
        if(busy||requiresCartReview){event.preventDefault();return;}
        var addons=selectedAddons();if(!addons.length)return;
        event.preventDefault();
        var variant=currentVariant();if(!variant||!variant.available)return;
        var items=buildCartItems(new FormData(form).entries(),addons);
        busy=true;form.setAttribute('aria-busy','true');addonFieldset.disabled=true;if(select)select.disabled=true;
        if(rosePicker)rosePicker.querySelectorAll('button').forEach(function(button){button.disabled=true;});
        root.querySelectorAll('[data-product-add]').forEach(function(button){button.disabled=true;});
        root.querySelectorAll('[data-add-label]').forEach(function(node){node.textContent=config.addingLabel;});
        try{
          var response=await fetch(config.cartAddUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
          var result=await response.json();
          if(!response.ok||!Array.isArray(result.items)||result.items.length!==items.length)throw new Error('cart-review-required');
          window.location.assign(config.cartUrl);
        }catch(error){
          requiresCartReview=true;
          var feedback=root.querySelector('[data-addon-feedback]');
          feedback.querySelector('[data-addon-error]').textContent=config.addonError;feedback.hidden=false;feedback.focus();
          root.querySelectorAll('[data-add-label]').forEach(function(node){node.textContent=config.availableLabel;});
        }finally{busy=false;form.removeAttribute('aria-busy');}
      });
      updateTotals();
    }
    if(select)select.addEventListener('change',function(){
      var variant=findVariant(config.variants,select.value);
      if(!variant)return;
      root.querySelectorAll('[data-variant-price]').forEach(function(node){node.textContent=variant.price;});
      root.querySelectorAll('[data-product-add]').forEach(function(button){button.disabled=!variant.available||busy||requiresCartReview;});
      root.querySelectorAll('[data-add-label]').forEach(function(node){node.textContent=variant.available?config.availableLabel:config.soldOutLabel;});
      var url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState(null,'',url);
      root.querySelectorAll('[data-peer-titles]').forEach(function(link){var titles=JSON.parse(link.dataset.peerTitles),ids=JSON.parse(link.dataset.peerIds),index=titles.indexOf(variant.title);if(index<0)return;var peerUrl=new URL(link.href);peerUrl.searchParams.set('variant',ids[index]);link.href=peerUrl.href;});
      if(variant.image&&!root.querySelector('.qr-photo--editorial')){var image=root.querySelector('.qr-main-image');image.src=variant.image;image.removeAttribute('srcset');}
      updateTotals();
    });
    root.querySelectorAll('[data-gallery-src]').forEach(function(button){button.addEventListener('click',function(){
      var image=root.querySelector('.qr-main-image');image.src=button.dataset.gallerySrc;image.removeAttribute('srcset');image.alt=button.dataset.galleryAlt;
      var stage=root.querySelector('.qr-photo');stage.classList.toggle('qr-photo--editorial',button.dataset.galleryKind==='editorial');stage.classList.toggle('qr-photo--cutout',button.dataset.galleryKind==='cutout');
      stage.dataset.crop=button.dataset.galleryCrop||'';
      stage.classList.toggle('qr-photo--measurements',button.dataset.galleryKind==='measurements');stage.dataset.measurements=button.dataset.galleryMeasurements||'';
      root.querySelector('[data-gallery-caption]').textContent=button.dataset.galleryCaption;
      root.querySelectorAll('[data-gallery-src]').forEach(function(item){item.setAttribute('aria-pressed',String(item===button));});
      root.querySelector('[data-gallery-count]').textContent=button.dataset.galleryIndex+' / '+root.querySelectorAll('[data-gallery-src]').length;
    });});
    var experienceColors=Array.from(root.querySelectorAll('[data-experience-color]'));
    function showExperienceColor(option){
      var firstPhoto=root.querySelector('[data-gallery-index="1"]');
      if(!option||!option.dataset.image||!firstPhoto)return;
      firstPhoto.dataset.gallerySrc=option.dataset.image;
      firstPhoto.dataset.galleryAlt=option.dataset.alt;
      firstPhoto.dataset.galleryCrop='square-bottom';
      var thumbnail=firstPhoto.querySelector('img');
      if(thumbnail){thumbnail.src=option.dataset.thumb;thumbnail.removeAttribute('srcset');}
      root.querySelector('[data-experience-color-name]').textContent=option.value;
      firstPhoto.click();
    }
    experienceColors.forEach(function(input){input.addEventListener('change',function(){
      if(!input.checked)return;
      showExperienceColor(input);
      var colorUrl=new URL(location.href);colorUrl.searchParams.set('cor',input.dataset.color);history.replaceState(null,'',colorUrl);
    });});
    if(experienceColors.length){
      var requestedColor=new URL(location.href).searchParams.get('cor');
      var requestedChoice=experienceColors.find(function(input){return input.dataset.color===requestedColor;});
      if(requestedChoice){requestedChoice.checked=true;showExperienceColor(requestedChoice);}
    }
    var message=root.querySelector('[data-message]');
    if(message)message.addEventListener('input',function(){root.querySelector('[data-message-count]').textContent=message.value.length+' / 1200';});
  }
  function start(){document.querySelectorAll('[data-qroses-product]').forEach(initialize);}
  start();document.addEventListener('shopify:section:load',start);
}());
